// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniCartStyles } from "@conklin/App/Components/MiniCart/MiniCart";
import IconArrowRight from "@conklin/XDL/Icons/IconArrowRight";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, styledScrollbar } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

miniCartStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 440px;
        min-width: 250px;
    `,
};

miniCartStyles.centerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 440px;
        min-width: 250px;
        padding: 12px;
    `,
};

miniCartStyles.notifyWrapper = {
    css: css`
        padding: 12px;
    `,
};

miniCartStyles.noCartLinesNotify = {
    css: css`
        margin-bottom: 0;
    `,
};

miniCartStyles.cartLinesContainer = {
    css: css`
        padding: 12px 0 0 12px;
    `,
};

miniCartStyles.cartLinesWrapper = {
    css: css`
        position: relative;
        min-height: 100px;
        max-height: 560px;
        padding-right: 12px;
        overflow-x: hidden;
        ${styledScrollbar(8)}
        overflow-y: scroll;

        @media screen and (max-height: 850px) {
            max-height: 435px;
        }
    `,
};

miniCartStyles.productAvailabilityStyles = {
    container: {
        gap: 0,
        css: css`
            width: auto;
            flex: 1 0 auto;
        `,
    },
};

miniCartStyles.bottomWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        border-top: 1px solid ${color("common.ui6")};
        padding: 12px;
        row-gap: 12px;
    `,
};

miniCartStyles.bottomSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
    `,
};

miniCartStyles.itemsCount = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

miniCartStyles.totalItem = {
    css: css`
        display: flex;
        align-items: center;
        margin-left: auto;
    `,
};

miniCartStyles.totalLabel = {
    size: 14,
    weight: fontConfig.weight.regular,
    lineHeight: "22px",
    css: css`
        margin-right: 4px;
    `,
};

miniCartStyles.totalValue = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

miniCartStyles.viewCartButton = {
    variant: "secondary",
};

miniCartStyles.addToCartMessage = {
    size: 12,
    lineHeight: "14px",
    css: css`
        display: block;
        margin-bottom: 12px;
    `,
};

miniCartStyles.totalCountValue = {
    size: 14,
    lineHeight: "22px",
    weight: fontConfig.weight.bold,
};

miniCartStyles.checkoutButton = {
    sizeVariant: "large",
    icon: { src: IconArrowRight, position: "right" },
};
